import script from "./aiLabels.vue?vue&type=script&lang=ts&setup=true"
export * from "./aiLabels.vue?vue&type=script&lang=ts&setup=true"

import "./aiLabels.vue?vue&type=style&index=0&id=fcc69b38&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcc69b38"]])

export default __exports__